<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.data_import')"/>
        <div class="list-content mt-2" style="overflow-x: hidden">
            <div clasS="row px-2">
                <div class="col-sm-6 pt-1">
                  <span class="title">{{ $t('storm_sewers.sewers') }}</span>
                </div>
                <div class="col-sm-6">
                  <div class="button-container col-sm-12 trip-buttons">
                    <button
                      class="btn btn-outline-primary btn-sm form-button"
                      @click="selectedDataType = SEWERS"
                    >
                      {{ $t('common.import_from_file') }}
                    </button>
                  </div>
                </div>
            </div>
            <div class="row px-2">
                <div class="col-sm-6 pt-1">
                  <span class="title">{{ $t('storm_sewers.drains') }}</span>
                </div>
                <div class="col-sm-6">
                  <div class="button-container col-sm-12 trip-buttons">
                    <button
                      class="btn btn-outline-primary btn-sm form-button"
                      @click="selectedDataType = DRAINS"
                    >
                      {{ $t('common.import_from_file') }}
                    </button>
                  </div>
                </div>
            </div>

            <storm-sewer-importer
                v-if="selectedDataType === SEWERS"
                @close="selectedDataType = null"
            />

            <storm-drain-importer
                v-if="selectedDataType === DRAINS"
                @close="selectedDataType = null"
            />
        </div>
    </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import StormSewerImporter from "@/components/dataimport/StormSewerImporter";
import StormDrainImporter from "@/components/dataimport/StormDrainImporter";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'DataImporter',
    components: {Navbar, StormDrainImporter, StormSewerImporter},
    mixins: [restApi],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            SEWERS: 1,
            DRAINS: 2,
            selectedDataType: null
        }
    },

    methods: {
    }
}
</script>
